module.exports = __webpack_public_path__ + "9bf1dab5385cad42031beb96a172c4c3.png";